import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './store';
import App from './App';
import registerServiceWorker from './registerServiceWorker';

import './Styles/css/bootstrap.css';
import './Styles/css/bootstrap-grid.css';
import './Styles/css/style.css';
ReactDOM.render(
	<BrowserRouter>
	<Provider store={store}>
    <App/>
  </Provider>
  </BrowserRouter>,
   document.getElementById('root'));
registerServiceWorker();
